module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/wow-slider/wow-fade-in-left-big/wow-fade-in-left-big.component.scss
// module id = ./src/app/features/wow-slider/wow-fade-in-left-big/wow-fade-in-left-big.component.scss
// module chunks = main